import React, { useState } from "react";
import ToggleSwitch from "../components/ToggleSwitch";
import { BeatLoader } from "react-spinners";
import toast from "react-hot-toast";
import { api } from "../../../../../api/zoom";

import { useNavigate } from "react-router";
import SingleSelectDropdown from "../../../../../pages/Admin/components/SingleSelectDropdown";

const Options = [
  { label: "No Recording", value: "no" },
  { label: "Local Drive", value: "drive" },
  { label: "Zoom Cloud", value: "cloud" },
];
const ZoomSettings = ({ nextStep, prevStep, formData }) => {
  const navigate = useNavigate();
  const orgId = JSON.parse(window.sessionStorage.getItem("user"))?.org?.id;

  const [recordType, setRecordType] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIdLoggedIn] = useState(false);
  const [settings, setSettings] = useState({
    setting1: false,
    setting2: false,
    setting3: false,
    setting4: false,
    setting5: false,
    setting6: false,
    setting7: false,
    setting8: false,
  });

  const handleToggleChange = (settingName) => {
    setSettings({
      ...settings,
      [settingName]: !settings[settingName],
    });
  };

  const handleSelectedActivity = (option) => {
    setRecordType(option.value);
  };

  const handleCreateMeeting = async () => {
    let payload = {
      agenda: formData.summary,
      topic: formData.topic,
      startTime: formData.dateTime,
      duration: formData.duration,
      timezone: formData.selectTimeZone,
      default_password: true,
      password: formData.password,
      private_meeting: formData.meetingType,
      enableRecording: formData.isRecording,
      settings: {
        joinBeforeHost: settings.setting1,
        hostVideo: settings.setting2,
        participantVideo: settings.setting3,
        muteUponEntry: settings.setting4,
        meetingAuthentication: settings.setting5,
        autoRecording: recordType,
         // new updates below
         requireRegistration: settings.setting6, // false
         registrationType: settings.setting6 ? "auto" : null,  // manual // if require registration is true, default is null         
         closeRegistration: settings.setting7,
         isJoinButtonVisible: settings.setting8
      },
    };
    
    setLoading(true);
    try {
      const response = await api.createZoomMeeting({ orgId, payload });
      setIdLoggedIn(true);
      navigate("/admin/zoom");
      toast.success(response.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tracking-normal">
      {" "}
      <div className="flex flex-col bg-white rounded-2xl border border-gray-300">
        <div className="grid grid-cols-3 gap-2 items-center p-6  border-b">
          <ToggleSwitch
            checked={settings.setting1}
            onChange={() => handleToggleChange("setting1")}
          />
          <label htmlFor="setting1" className="">
            <h3 className="text-base font-medium text-[#1D1F2C]">
              Join Before Host
            </h3>
          </label>
          <p className="text-base   text-[#667085]">
            Learners can join meeting before host starts
          </p>
        </div>
        <div className="grid grid-cols-3 gap-2 items-center p-6  border-b">
          <ToggleSwitch
            checked={settings.setting2}
            onChange={() => handleToggleChange("setting2")}
          />
          <label htmlFor="setting2" className="">
            <h3 className="text-base font-medium text-[#1D1F2C]">Host Video</h3>
          </label>
          <p className="text-base   text-[#667085]">
            Host will join meeting with video enabled
          </p>
        </div>
        <div className="grid grid-cols-3 gap-2 items-center p-4  border-b">
          <ToggleSwitch
            checked={settings.setting3}
            onChange={() => handleToggleChange("setting3")}
          />
          <label htmlFor="setting3" className="">
            <h3 className="text-base font-medium text-[#1D1F2C]">
              Learner Video
            </h3>
          </label>
          <p className="text-base   text-[#667085]">
            Learners will join meeting with video enabled
          </p>
        </div>
        <div className="grid grid-cols-3 gap-2 items-center p-4  border-b">
          <ToggleSwitch
            checked={settings.setting4}
            onChange={() => handleToggleChange("setting4")}
          />
          <label htmlFor="setting4" className="">
            <h3 className="text-base font-medium text-[#1D1F2C]">
              Mute Learners
            </h3>
          </label>
          <p className="text-base font-medium  text-[#667085]">
            Learners will join meeting with audio muted
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 items-center p-4  border-b w-full">
          <div className="w-fit">
            <ToggleSwitch
              checked={settings.setting5}
              onChange={() => handleToggleChange("setting5")}
            />
          </div>
          <label htmlFor="setting5" className="w-fit">
            <h3 className="text-base font-medium text-[#1D1F2C]">
              Enforce Login
            </h3>
          </label>
          <div className="">
            <p className="text-base font-medium  text-[#667085]">
              Only learners logged into zoom app can join meeting
            </p>
          </div>
        </div>

       <div className="grid grid-cols-3 gap-2 items-center p-6 border-b">
          <ToggleSwitch
            checked={settings.setting6}
            onChange={() => handleToggleChange("setting6")}
          />
          <label htmlFor="setting6">
            <h3 className="text-base font-medium text-[#1D1F2C]">Require Registration</h3>
          </label>
          <p className="text-base text-[#667085]">
            Require learners to register before attending
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 items-center p-6 border-b">
          <ToggleSwitch
            checked={settings.setting7}
            onChange={() => handleToggleChange("setting7")}
          />
          <label htmlFor="setting7">
            <h3 className="text-base font-medium text-[#1D1F2C]">Close Registration</h3>
          </label>
          <p className="text-base text-[#667085]">
            Close registration when meeting starts
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 items-center p-6 border-b">
          <ToggleSwitch
            checked={settings.setting8}
            onChange={() => handleToggleChange("setting8")}
          />
          <label htmlFor="setting8">
            <h3 className="text-base font-medium text-[#1D1F2C]">Join Button Visible</h3>
          </label>
          <p className="text-base text-[#667085]">
            Show join button on Zoom meeting page
          </p>
        </div>
      
        <div className="my-3 px-6">
          <h2 className="text-base font-semibold text-[#1D1F2C]">
            Recording Settings
          </h2>
          <p className="text-xs text-[#667085] font-normal">
            Select where you want to record
          </p>
          <div className="flex flex-col w-fit mt-2">
            <SingleSelectDropdown
              options={Options}
              onSelect={handleSelectedActivity}
              placeholder="Select storage"
              placeholderColor="#A5A5A5"
            />
          </div>
          {/* <div className="flex items-center gap-x-3 mt-3">
            <div className="flex gap-x-3 items-center">
              <div className="h-4 w-4 rounded-full bg-[#0E316E]"></div>
              <p className="text-sm font-semibold text-[#1D1F2C]">
                No Recordings
              </p>
            </div>
            <div className="flex gap-x-3 items-center">
              <div className="h-4 w-4 rounded-full bg-[#0E316E]"></div>
              <p className="text-sm font-semibold text-[#1D1F2C]">
                Local Drive
              </p>
            </div>
            <div className="flex gap-x-3 items-center">
              <div className="h-4 w-4 rounded-full bg-[#0E316E]"></div>
              <p className="text-sm font-semibold text-[#1D1F2C]">Zoom Cloud</p>
            </div>
          </div> */}
        </div>


      </div>
      <div className="flex  gap-x-6 items-center py-10">
        <button
          type="button"
          onClick={prevStep}
          className="w-full font-semibold bg-[#E8EDF4] border border-customBlue text-customBlue p-3 rounded-lg text-xs"
        >
          Back
        </button>
        <button
          type="submit"
          onClick={handleCreateMeeting}
          disabled={loading || isLoggedIn}
          className="w-full font-semibold bg-customBlue text-white p-3 rounded-lg text-xs"
        >
          {loading ? (
            <div className="flex justify-center">
              {" "}
              <BeatLoader color="#fff" />{" "}
            </div>
          ) : isLoggedIn ? (
            "created"
          ) : (
            "Create Meeting"
          )}
        </button>
      </div>
    </div>
  );
};

export default ZoomSettings;
